"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerIconContainer = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _spacing = require("../../../constants/spacing");
var _bannerTheme = require("./bannerTheme");
const BannerIconContainer = (0, _styled.default)("div")`
    // Ensure we wrap the Icon itself with no extra default spacing.
    display: inline-flex;
    color: ${_ref => {
  let {
    themeMode,
    type
  } = _ref;
  return _bannerTheme.bannerTheme.iconColor[type](themeMode);
}};
    margin: ${_spacing.sizes.small}px 0 ${_spacing.sizes.small}px ${_spacing.sizes.small}px;
`;
exports.BannerIconContainer = BannerIconContainer;
//# sourceMappingURL=BannerIconContainer.js.map